import './App.css';
import './Form/Input.css';
import {useState} from "react";
import Input from "./Form/Input";
import CalculationResult from "./Form/CalculationResult";

function parseNumber(value) {
    if (value.includes(",")) {
        value = value.replace(',', '.');
    }
    return parseFloat(value);
}

function saveValues(values) {
    localStorage.setItem("leasing_form_values", JSON.stringify(values));
}

function loadValues ()
{
    const values = localStorage.getItem("leasing_form_values");
    return JSON.parse(values ?? '{}');
}


function App() {
  const [formData, setFormData] = useState(() => {
      const existingValues = loadValues();
      return {
          msrp: "",
          taxPercent: "",
          leasingDownPayment: "",
          leasingMonthlyPayment: "",
          leasingLength: "",
          usedCarPrice: "",
          feeValue: "",
          paymentType: "cash",
          financeApr: "",
          financeLength: "",
          financeDownPayment: "",
          ...existingValues
      }
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (event) => {
      setIsSubmitted(false);
    const { name, value } = event.target;
    const isNumber = name !== 'paymentType';
    setFormData((prevFormData) => ({ ...prevFormData, [name]: isNumber ? parseNumber(value) : value }));
  };


  const handleSubmit = () => {
      saveValues(formData);
      setIsSubmitted(true);
  }

  const handleBack = () => {
      setIsSubmitted(false);
  }

  let content = "";
  const isFinance = formData.paymentType === 'finance';

  if (isSubmitted) {
      content = (<div className="App">
          <button className="button" onClick={handleBack}>Назад</button>

          <CalculationResult formData={formData}/>
      </div>);
  } else {
      content = (<>
          <Input name="msrp" onChange={handleChange} value={formData.msrp}
                 label="Стоимость авто у дилера (Без налога)"/>
          <Input name="taxPercent" onChange={handleChange} value={formData.taxPercent}
                 label="% Sales Tax (вводить просто цифру - например '10.3' если налог 10.3% "/>
          <Input name="leasingDownPayment" onChange={handleChange} value={formData.leasingDownPayment}
                 label="Сумма, которую просят оплатить как down payment к лизингу (Без налога)"/>
          <Input name="leasingMonthlyPayment" onChange={handleChange} value={formData.leasingMonthlyPayment}
                 label="Ежемесячный платеж по лизингу (Без налога)"/>
          <Input name="leasingLength" onChange={handleChange} value={formData.leasingLength}
                 label="Срок лизинга (месяцы)"/>
          <Input name="feeValue" onChange={handleChange} value={formData.feeValue}
                 label="Documentary fee / registration fee / любые доп fee которые требуются чтоб поставить машину на учет"/>
          <Input name="usedCarPrice" onChange={handleChange} value={formData.usedCarPrice} label="Стоимость машины на момент окончания лизинга (Просто идем на kbb или cars.com и смотрим,
            сколько стоит такая же машина Б/y (если лиз на 3 года - то смотрим трехлетние машины, и т.п.)"/>

          <div className="form-group">
              <div className="form-head">Кредит или за кэш?</div>
              <div className="input">
                  <input type="radio" name="paymentType" onChange={handleChange} id="payment_type_finance"
                         value="finance" checked={isFinance}/>
                  <label htmlFor="payment_type_finance">Кредит</label>
                  <input type="radio" name="paymentType" onClick={handleChange} id="payment_type_cash"
                         value="cash" checked={!isFinance}/>
                  <label htmlFor="payment_type_cash"> Кэш</label>

              </div>
          </div>
          {isFinance ?
              <div className="FinanceForm">
                  <h2>Данные по кредиту</h2>
                  <Input name="financeApr" onChange={handleChange} value={formData.financeApr}
                         label="APR - % по кредиту (вводить просто цифру - например '5.5'. Если кредита нет - оставлять 0)"/>

                  <Input name="financeDownPayment" onChange={handleChange} value={formData.financeDownPayment}
                         label="Down payment по кредиту"/>
                  <Input name="financeLength" onChange={handleChange} value={formData.financeLength}
                         label="Срок кредита в месяцах"/>
              </div>
              : ''}


          <button className="button" onClick={handleSubmit}>Рассчитать</button>
      </>)
  }


    return (
        <div className="App">
            <div className="Intro">
                Привет!
                <br/><br/>
                <p>
                    Это калькулятор выгодности лизинга. Он отвечает на вопрос: Что выгоднее, покупка или лизинг?
                </p>
            </div>


            {content}
        </div>
    );
}

export default App;
